import { useRef } from "react"

import {
  Text,
  textSizes,
} from "../../../../../apps/portal/src/skinui/text/text"

import { useFontStyles } from "./utils/use-font-styles"

const Row = ({ size }) => {
  const ref = useRef()
  const { letterSpacing, fontSize, lineHeight } = useFontStyles(
    ref?.current?.children?.[0]
  )

  return (
    <tr>
      <td>
        <Text size={size}>{letterSpacing}</Text>
      </td>
      <td ref={ref}>
        <Text size={size}>Text {size}</Text>
      </td>
      <td>
        <Text size={size}>{fontSize}</Text>
      </td>
      <td>
        <Text size={size}>{lineHeight}</Text>
      </td>
    </tr>
  )
}

const Texts = () => {
  return (
    <div
      sx={{
        p: 2,
      }}
    >
      <div sx={{ my: 2 }}>
        <strong>Tip:</strong> resize the window to see styles for different
        screen sizes
      </div>
      <table
        sx={{
          borderCollapse: "collapse",
          border: "2px solid black",
          th: {
            border: "2px solid black",
            py: 3,
            px: 4,
            textAlign: "center",
          },
          td: {
            border: "2px solid black",
            py: 4,
            px: 5,
            textAlign: "center",
          },
        }}
      >
        <thead>
          <tr>
            <th>Letter Spacing</th>
            <th>Example</th>
            <th>Font Size</th>
            <th>Line Height</th>
          </tr>
        </thead>
        <tbody>
          {textSizes.map((size) => (
            <Row key={size} size={size} />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Texts
